
import { MoodKeyMapping, MusicalKey } from '@/types/production.types';

export const MOOD_KEY_MAPPINGS: MoodKeyMapping[] = [
  // DARK / HEAVY
  {
    mood: 'dark',
    primaryKeys: ['E', 'D', 'B', 'C'],
    primaryModes: ['minor', 'dorian'],
    tempoTendency: 'slow',
    energyRange: [3, 6]
  },
  {
    mood: 'heavy',
    primaryKeys: ['E', 'D', 'C', 'B'],
    primaryModes: ['minor', 'dorian', 'blues'],
    tempoTendency: 'variable',
    energyRange: [6, 10]
  },
  {
    mood: 'ominous',
    primaryKeys: ['E', 'B', 'D'],
    primaryModes: ['minor'],
    tempoTendency: 'slow',
    energyRange: [2, 5]
  },
  {
    mood: 'menacing',
    primaryKeys: ['E', 'C', 'D'],
    primaryModes: ['minor', 'dorian'],
    tempoTendency: 'mid',
    energyRange: [5, 8]
  },
  {
    mood: 'crushing',
    primaryKeys: ['E', 'D', 'C', 'B'],
    primaryModes: ['minor', 'blues'],
    tempoTendency: 'slow',
    energyRange: [8, 10]
  },
  {
    mood: 'haunting',
    primaryKeys: ['D', 'A', 'B', 'E'],
    primaryModes: ['minor', 'dorian'],
    tempoTendency: 'slow',
    energyRange: [1, 4]
  },
  
  // TRIUMPHANT / POWERFUL
  {
    mood: 'triumphant',
    primaryKeys: ['D', 'G', 'A', 'E'],
    primaryModes: ['major', 'mixolydian'],
    tempoTendency: 'mid',
    energyRange: [7, 10]
  },
  {
    mood: 'powerful',
    primaryKeys: ['E', 'A', 'D'],
    primaryModes: ['major', 'minor'],
    tempoTendency: 'mid',
    energyRange: [7, 10]
  },
  {
    mood: 'anthemic',
    primaryKeys: ['D', 'E', 'G', 'A'],
    primaryModes: ['major'],
    tempoTendency: 'mid',
    energyRange: [8, 10]
  },
  {
    mood: 'epic',
    primaryKeys: ['D', 'E', 'A'],
    primaryModes: ['major', 'minor'],
    tempoTendency: 'variable',
    energyRange: [7, 10]
  },
  
  // MELANCHOLY / SAD
  {
    mood: 'melancholy',
    primaryKeys: ['D', 'A', 'E', 'G'],
    primaryModes: ['minor', 'dorian'],
    tempoTendency: 'slow',
    energyRange: [2, 5]
  },
  {
    mood: 'sad',
    primaryKeys: ['D', 'A', 'E'],
    primaryModes: ['minor'],
    tempoTendency: 'slow',
    energyRange: [1, 4]
  },
  {
    mood: 'longing',
    primaryKeys: ['E', 'A', 'D'],
    primaryModes: ['minor', 'dorian'],
    tempoTendency: 'slow',
    energyRange: [2, 5]
  },
  {
    mood: 'nostalgic',
    primaryKeys: ['G', 'D', 'A', 'C'],
    primaryModes: ['major', 'mixolydian'],
    tempoTendency: 'mid',
    energyRange: [3, 6]
  },
  
  // UPLIFTING / HAPPY
  {
    mood: 'uplifting',
    primaryKeys: ['G', 'D', 'A', 'C'],
    primaryModes: ['major'],
    tempoTendency: 'mid',
    energyRange: [6, 9]
  },
  {
    mood: 'joyful',
    primaryKeys: ['C', 'G', 'D', 'A'],
    primaryModes: ['major'],
    tempoTendency: 'fast',
    energyRange: [7, 10]
  },
  {
    mood: 'hopeful',
    primaryKeys: ['G', 'C', 'D'],
    primaryModes: ['major'],
    tempoTendency: 'mid',
    energyRange: [5, 8]
  },
  
  // AGGRESSIVE / ANGRY
  {
    mood: 'aggressive',
    primaryKeys: ['E', 'D', 'A', 'B'],
    primaryModes: ['minor', 'dorian'],
    tempoTendency: 'fast',
    energyRange: [8, 10]
  },
  {
    mood: 'angry',
    primaryKeys: ['E', 'D', 'C'],
    primaryModes: ['minor'],
    tempoTendency: 'fast',
    energyRange: [8, 10]
  },
  {
    mood: 'defiant',
    primaryKeys: ['E', 'A', 'D'],
    primaryModes: ['minor', 'major'],
    tempoTendency: 'mid',
    energyRange: [7, 10]
  },
  
  // LAID-BACK / CHILL
  {
    mood: 'laid-back',
    primaryKeys: ['G', 'D', 'A', 'E'],
    primaryModes: ['mixolydian', 'major'],
    tempoTendency: 'slow',
    energyRange: [3, 6]
  },
  {
    mood: 'groovy',
    primaryKeys: ['E', 'A', 'D', 'G'],
    primaryModes: ['mixolydian', 'dorian'],
    tempoTendency: 'mid',
    energyRange: [5, 8]
  },
  {
    mood: 'swagger',
    primaryKeys: ['E', 'A', 'D'],
    primaryModes: ['mixolydian', 'blues'],
    tempoTendency: 'mid',
    energyRange: [6, 9]
  },
  {
    mood: 'smoky',
    primaryKeys: ['A', 'G', 'E', 'D'],
    primaryModes: ['blues', 'dorian', 'mixolydian'],
    tempoTendency: 'slow',
    energyRange: [2, 5]
  },
  
  // EMOTIONAL / VULNERABLE
  {
    mood: 'emotional',
    primaryKeys: ['D', 'G', 'A', 'E'],
    primaryModes: ['minor', 'major'],
    tempoTendency: 'slow',
    energyRange: [3, 7]
  },
  {
    mood: 'vulnerable',
    primaryKeys: ['G', 'D', 'A'],
    primaryModes: ['major', 'minor'],
    tempoTendency: 'slow',
    energyRange: [2, 5]
  },
  {
    mood: 'intimate',
    primaryKeys: ['G', 'D', 'C', 'A'],
    primaryModes: ['major'],
    tempoTendency: 'slow',
    energyRange: [1, 4]
  },
  
  // REBELLIOUS / OUTLAW
  {
    mood: 'rebellious',
    primaryKeys: ['E', 'A', 'D'],
    primaryModes: ['mixolydian', 'major'],
    tempoTendency: 'mid',
    energyRange: [6, 9]
  },
  {
    mood: 'outlaw',
    primaryKeys: ['E', 'A', 'D', 'G'],
    primaryModes: ['mixolydian', 'major'],
    tempoTendency: 'mid',
    energyRange: [5, 8]
  },
  {
    mood: 'dangerous',
    primaryKeys: ['E', 'D', 'A'],
    primaryModes: ['minor', 'dorian'],
    tempoTendency: 'mid',
    energyRange: [6, 9]
  },
  
  // SPIRITUAL / TRANSCENDENT
  {
    mood: 'spiritual',
    primaryKeys: ['G', 'D', 'C', 'F'],
    primaryModes: ['major'],
    tempoTendency: 'mid',
    energyRange: [5, 9]
  },
  {
    mood: 'transcendent',
    primaryKeys: ['D', 'G', 'E'],
    primaryModes: ['major', 'dorian'],
    tempoTendency: 'slow',
    energyRange: [4, 8]
  },
  {
    mood: 'reverent',
    primaryKeys: ['G', 'C', 'D'],
    primaryModes: ['major'],
    tempoTendency: 'slow',
    energyRange: [3, 6]
  }
];

/**
 * Musical key definitions with emotional profiles
 */
export const MUSICAL_KEYS: MusicalKey[] = [
  // MAJOR KEYS
  {
    root: 'C',
    mode: 'major',
    displayName: 'C Major',
    relativeKey: 'A Minor',
    commonChords: ['C', 'F', 'G', 'Am', 'Dm', 'Em'],
    emotionalProfile: ['pure', 'bright', 'innocent', 'simple', 'clean']
  },
  {
    root: 'D',
    mode: 'major',
    displayName: 'D Major',
    relativeKey: 'B Minor',
    commonChords: ['D', 'G', 'A', 'Bm', 'Em', 'F#m'],
    emotionalProfile: ['triumphant', 'warm', 'joyful', 'optimistic', 'strong']
  },
  {
    root: 'E',
    mode: 'major',
    displayName: 'E Major',
    relativeKey: 'C# Minor',
    commonChords: ['E', 'A', 'B', 'C#m', 'F#m', 'G#m'],
    emotionalProfile: ['bright', 'joyful', 'powerful', 'uplifting', 'energetic']
  },
  {
    root: 'G',
    mode: 'major',
    displayName: 'G Major',
    relativeKey: 'E Minor',
    commonChords: ['G', 'C', 'D', 'Em', 'Am', 'Bm'],
    emotionalProfile: ['rustic', 'earthy', 'warm', 'optimistic', 'folksy']
  },
  {
    root: 'A',
    mode: 'major',
    displayName: 'A Major',
    relativeKey: 'F# Minor',
    commonChords: ['A', 'D', 'E', 'F#m', 'Bm', 'C#m'],
    emotionalProfile: ['confident', 'bright', 'hopeful', 'driving', 'strong']
  },
  
  // MINOR KEYS
  {
    root: 'A',
    mode: 'minor',
    displayName: 'A Minor',
    relativeKey: 'C Major',
    commonChords: ['Am', 'Dm', 'E', 'Em', 'F', 'G'],
    emotionalProfile: ['melancholy', 'pensive', 'introspective', 'dark', 'emotional']
  },
  {
    root: 'E',
    mode: 'minor',
    displayName: 'E Minor',
    relativeKey: 'G Major',
    commonChords: ['Em', 'Am', 'B', 'Bm', 'C', 'D'],
    emotionalProfile: ['dark', 'heavy', 'powerful', 'dramatic', 'intense']
  },
  {
    root: 'D',
    mode: 'minor',
    displayName: 'D Minor',
    relativeKey: 'F Major',
    commonChords: ['Dm', 'Gm', 'A', 'Am', 'Bb', 'C'],
    emotionalProfile: ['serious', 'profound', 'melancholy', 'dramatic', 'sad']
  },
  {
    root: 'B',
    mode: 'minor',
    displayName: 'B Minor',
    relativeKey: 'D Major',
    commonChords: ['Bm', 'Em', 'F#', 'F#m', 'G', 'A'],
    emotionalProfile: ['lonely', 'patient', 'contemplative', 'dark', 'heavy']
  },
  {
    root: 'C',
    mode: 'minor',
    displayName: 'C Minor',
    relativeKey: 'Eb Major',
    commonChords: ['Cm', 'Fm', 'G', 'Gm', 'Ab', 'Bb'],
    emotionalProfile: ['tragic', 'dark', 'heavy', 'ominous', 'brooding']
  },
  
  // DORIAN MODE
  {
    root: 'E',
    mode: 'dorian',
    displayName: 'E Dorian',
    commonChords: ['Em', 'F#m', 'G', 'A', 'Bm', 'C#dim'],
    emotionalProfile: ['dark-groovy', 'soulful', 'bluesy', 'jazzy', 'sophisticated']
  },
  {
    root: 'D',
    mode: 'dorian',
    displayName: 'D Dorian',
    commonChords: ['Dm', 'Em', 'F', 'G', 'Am', 'Bdim'],
    emotionalProfile: ['mysterious', 'groovy', 'modal', 'sophisticated', 'funky']
  },
  {
    root: 'A',
    mode: 'dorian',
    displayName: 'A Dorian',
    commonChords: ['Am', 'Bm', 'C', 'D', 'Em', 'F#dim'],
    emotionalProfile: ['funky', 'soulful', 'smooth', 'minor-but-hopeful', 'cool']
  },
  
  // MIXOLYDIAN MODE
  {
    root: 'E',
    mode: 'mixolydian',
    displayName: 'E Mixolydian',
    commonChords: ['E', 'F#m', 'G#m', 'A', 'B', 'C#m', 'D'],
    emotionalProfile: ['bluesy', 'southern', 'rock', 'swagger', 'groovy']
  },
  {
    root: 'A',
    mode: 'mixolydian',
    displayName: 'A Mixolydian',
    commonChords: ['A', 'Bm', 'C#m', 'D', 'E', 'F#m', 'G'],
    emotionalProfile: ['rock', 'driving', 'southern', 'upbeat', 'confident']
  },
  {
    root: 'G',
    mode: 'mixolydian',
    displayName: 'G Mixolydian',
    commonChords: ['G', 'Am', 'Bm', 'C', 'D', 'Em', 'F'],
    emotionalProfile: ['folksy', 'earthy', 'americana', 'warm', 'rolling']
  },
  {
    root: 'D',
    mode: 'mixolydian',
    displayName: 'D Mixolydian',
    commonChords: ['D', 'Em', 'F#m', 'G', 'A', 'Bm', 'C'],
    emotionalProfile: ['country', 'folk', 'laid-back', 'sunny', 'open']
  },
  
  // BLUES SCALE
  {
    root: 'E',
    mode: 'blues',
    displayName: 'E Blues',
    commonChords: ['E7', 'A7', 'B7'],
    emotionalProfile: ['gritty', 'raw', 'soulful', 'pain', 'cathartic']
  },
  {
    root: 'A',
    mode: 'blues',
    displayName: 'A Blues',
    commonChords: ['A7', 'D7', 'E7'],
    emotionalProfile: ['classic', 'shuffle', 'swinging', 'confident', 'groovy']
  },
  {
    root: 'G',
    mode: 'blues',
    displayName: 'G Blues',
    commonChords: ['G7', 'C7', 'D7'],
    emotionalProfile: ['warm', 'earthy', 'acoustic-friendly', 'delta', 'traditional']
  }
];

/**
 * Get mood mapping by mood keyword
 */
export function getMoodMapping(mood: string): MoodKeyMapping | undefined {
  const normalizedMood = mood.toLowerCase();
  return MOOD_KEY_MAPPINGS.find(m => 
    m.mood.toLowerCase() === normalizedMood ||
    normalizedMood.includes(m.mood.toLowerCase())
  );
}

/**
 * Get all mood mappings that partially match
 */
export function getMatchingMoods(moods: string[]): MoodKeyMapping[] {
  const normalizedMoods = moods.map(m => m.toLowerCase());
  return MOOD_KEY_MAPPINGS.filter(mapping => 
    normalizedMoods.some(m => 
      m.includes(mapping.mood.toLowerCase()) || 
      mapping.mood.toLowerCase().includes(m)
    )
  );
}

/**
 * Get musical key by root and mode
 */
export function getMusicalKey(root: string, mode: string): MusicalKey | undefined {
  return MUSICAL_KEYS.find(k => 
    k.root.toLowerCase() === root.toLowerCase() && 
    k.mode === mode
  );
}

/**
 * Get all keys matching emotional profile
 */
export function getKeysByEmotion(emotion: string): MusicalKey[] {
  const normalizedEmotion = emotion.toLowerCase();
  return MUSICAL_KEYS.filter(k => 
    k.emotionalProfile.some(e => 
      e.toLowerCase().includes(normalizedEmotion) ||
      normalizedEmotion.includes(e.toLowerCase())
    )
  );
}

/**
 * Get all keys by mode
 */
export function getKeysByMode(mode: string): MusicalKey[] {
  return MUSICAL_KEYS.filter(k => k.mode === mode);
}
